/* eslint-disable no-param-reassign */
/**
 * Waits for a ref property to become truthy
 * @param {Object} ref - React ref object
 * @param {string} key - Property key to wait for
 * @param {boolean} skip - Skip waiting if true
 * @param {number} timeout - Timeout in milliseconds
 * @returns {Promise} Resolves when ref[key] becomes truthy
 */
export const waitForRefValue = (ref, key, skip = false, timeout = 10000) => {
  return new Promise((resolve, reject) => {
    if (ref.current[key] || skip) resolve();
    else if (ref.current.resolver) reject(new Error('Ref already has resolver'));
    else {
      const timeoutId = setTimeout(() => {
        ref.current.resolver = null;
        reject(new Error(`Ref failed to resolve after ${timeout}`));
      }, timeout);

      ref.current.resolver = () => {
        clearTimeout(timeoutId);
        resolve();
        ref.current.resolver = null;
      };
    }
  });
};